module.exports = "/_next/static/images/4d5f5a5003f69eb03b71341e07d73695-vigilado.png";